import { render, staticRenderFns } from "./personCost.vue?vue&type=template&id=cf8b74da&scoped=true"
import script from "./personCost.vue?vue&type=script&lang=js"
export * from "./personCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8b74da",
  null
  
)

export default component.exports